<template>
	<div class="result">
		<transition name="slide-fade">
			<div class="answer-wrap">
				<div class="answer-title">
					★結果C
					<div class="text">睡眠環境を見直してみましょう</div>
				</div>
				<div class="answer-body">
					<p>
睡眠の質UPには、生活習慣と睡眠環境（寝室や寝具）の両方を整えることが大切。あなたの場合、とくに睡眠環境に改善の余地がありそうです。</p>
					<div class="sub-cts"><h2>★改善へのアドバイス</h2>
						<p>ぐっすり眠れるよう、睡眠環境を整えましょう。「寝室」は、温度（夏：25～28℃、冬：16～20℃）、湿度（夏：40～60％、冬：50％以上）をキープ、光（0.3lx：晴れた日の月明り程度）、音（40㏈以下：図書館や昼の静かな住宅街）が目安です。「寝具」では、それぞれの条件にあった寝具を選びましょう。（掛けふとん：温かさ・さわやかさ・軽さ・フィット感等、敷ふとん：極端に沈み込まない・体の凸部分の圧迫を和らげる・さわやかさ等、枕：自分に合った高さ・好みの硬さ等）</p>
					</div>
					<div class="sub-cts">
						<h2>▼こちらもCHECK</h2>
						<ul>
							<li><a href="https://xn--z8js3azm.com/beauty/6">寝苦しいのは「寝床内環境」のせいかも？布団の中の温度・湿度を快適に整える3つのポイント</a></li>
						</ul>
					</div>
				</div>
				<div class="btn-area">
					<button @click="next(0)" class="btnReset">スタートに戻る</button>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
export default {
	name: 'ResultCts03',
	methods: {
		next(page) {
			this.$store.dispatch('next', page)
		},
		onComplete: function () {
			this.btnFlg = true;
		}
	}
}
</script>